import React, { useState, useEffect } from "react";

export default function Modal({
    show,
    toggle,
    blank,
    callback,
    children,
    title,
    acceptText,
}) {
    const [mostrar, setMostrar] = useState(false);

    window.addEventListener("keyup", (e) => {
        if (e.key === "Escape") {
            setMostrar(false);
        }
    });

    useEffect(() => {
        setMostrar(show);
    }, [show]);

    if (blank) {
        return (
            mostrar && (
                <div className={`popup ${mostrar ? "active" : ""}`}>
                    <div className='popup__content'>{children}</div>
                    <div className='popup__overlay'></div>
                </div>
            )
        );
    }

    return (
        mostrar && (
            <div className={`popup ${mostrar ? "active" : ""}`}>
                <div className='popup__content'>
                    <div className='popup__header'>{title}</div>
                    <div className='popup__body'>{children}</div>
                    <div className='popup__footer'>
                        <button
                            onClick={() => {
                                setMostrar(false);
                                toggle();
                            }}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        <button
                            onClick={() => {
                                callback ? callback() : toggle();
                                toggle();
                            }}
                            className='btn btn-primary'>
                            {acceptText || "Aceptar"}
                        </button>
                    </div>
                </div>
                <div className='popup__overlay'></div>
            </div>
        )
    );
}
